<template>
  <div
    class="relative px-3 py-2.5 border-b border-[#DBDEE6] hover:bg-gray-200/80 cursor-pointer w-full flex items-center gap-2 justify-between transition"
  >
    <span 
      class="w-full flex items-center gap-2 text-sm text-[#2D2D2D] font-normal"
      @click.prevent="$emit('click', folder)"
    >
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4"
      >
        <path
          d="M9.70833 4.04167L8.8252 2.27539C8.57103 1.76705 8.44393 1.51287 8.25433 1.32717C8.08667 1.16295 7.88459 1.03806 7.66273 0.961537C7.41184 0.875 7.12766 0.875 6.55931 0.875H3.53333C2.64658 0.875 2.20321 0.875 1.86451 1.04757C1.56659 1.19937 1.32437 1.44159 1.17257 1.73952C1 2.07821 1 2.52158 1 3.40833V4.04167M1 4.04167H13.0333C14.3635 4.04167 15.0285 4.04167 15.5366 4.30053C15.9834 4.52823 16.3468 4.89155 16.5745 5.33844C16.8333 5.84648 16.8333 6.51154 16.8333 7.84167V11.325C16.8333 12.6551 16.8333 13.3202 16.5745 13.8282C16.3468 14.2751 15.9834 14.6384 15.5366 14.8661C15.0285 15.125 14.3635 15.125 13.0333 15.125H4.8C3.46988 15.125 2.80481 15.125 2.29677 14.8661C1.84989 14.6384 1.48656 14.2751 1.25886 13.8282C1 13.3202 1 12.6551 1 11.325V4.04167Z"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ folder.name }}
    </span>

    <b-dropdown
      menu-class="bg-white p-0"
      toggle-class="p-0 text-primary hover:opacity-80 transition"
      right
    >
      <template #button-content>
        <div class="py-2">
          <svg
            width="20"
            height="5"
            viewBox="0 0 24 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="2.5"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
            <circle
              cx="12.0713"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
            <circle
              cx="21.3569"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
          </svg>
        </div>
      </template>

      <div class="flex flex-column w-[200px] p-3 gap-3 text-[15px]">
        <b-link
          class="link-muted font-normal"
          @click.prevent="$emit('edit', folder)"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 mr-2"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.8049 1.52858C11.5446 1.26823 11.1224 1.26823 10.8621 1.52858L1.52876 10.8619C1.40373 10.9869 1.3335 11.1565 1.3335 11.3333V14C1.3335 14.3682 1.63197 14.6666 2.00016 14.6666H4.66683C4.84364 14.6666 5.01321 14.5964 5.13823 14.4714L14.4716 5.13805C14.7319 4.8777 14.7319 4.45559 14.4716 4.19524L11.8049 1.52858ZM12.0002 5.72384L10.2763 3.99998L11.3335 2.94279L13.0574 4.66665L12.0002 5.72384ZM9.3335 4.94279L11.0574 6.66665L5.3335 12.3905L3.60964 10.6666L9.3335 4.94279ZM2.66683 11.6095L4.39069 13.3333H2.66683V11.6095Z"
              fill="currentColor"
            />
            <path
              d="M8.66683 13.3333C8.29864 13.3333 8.00016 13.6318 8.00016 14C8.00016 14.3682 8.29864 14.6666 8.66683 14.6666H14.0002C14.3684 14.6666 14.6668 14.3682 14.6668 14C14.6668 13.6318 14.3684 13.3333 14.0002 13.3333H8.66683Z"
              fill="currentColor"
            />
          </svg>

          Edit
        </b-link>

        <delete-confirm
          title="Are you sure?"
          @confirm="$emit('delete', folder)"
        >
          <template #activator="{on}">
            <b-link
              class="link-muted font-normal"
              v-on="on"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 mr-2"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                  fill="currentColor"
                />
                <path
                  d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                  fill="currentColor"
                />
                <path
                  d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Delete
            </b-link>
          </template>
        </delete-confirm>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import DeleteConfirm from '@/components/editor/modals/DeleteConfirm.vue'

export default {
  name: 'FavoritesFolder',
  components: {DeleteConfirm},
  props: {
    folder: {
      type: Object,
      required: false
    }
  }
}
</script>
